// src/components/QuizButton.tsx
import React from "react";
import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QuizButtonProps {
  onClick: () => void;
  iconsOnly?: boolean;
}

const QuizButton: React.FC<QuizButtonProps> = ({ onClick, iconsOnly = false }) => {
  // Använd samma stil som andra header-knappar för konsekvent utseende
  const headerButtonStyle = "bg-gray-800/50 text-gray-300 border border-gray-700 hover:bg-orange-300/10 hover:text-orange-300 transition-colors flex items-center justify-center h-9 w-9 p-0";

  if (iconsOnly) {
    return (
      <Button
        variant="outline"
        size="icon"
        className={headerButtonStyle}
        onClick={onClick}
        aria-label="Processquiz"
      >
        <BookOpen className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      className="bg-gray-800/50 text-gray-300 border border-gray-700 hover:bg-orange-300/10 hover:text-orange-300 transition-colors"
      onClick={onClick}
    >
      <BookOpen className="h-4 w-4 mr-2" />
      Processquiz
    </Button>
  );
};

export default QuizButton;